const CandidateMixin = {
    data() {
        return {
            candidate: { id: null }
        }
    },
    methods: {
        fetchCandidate( id ) {
            return this.axios.get( this.$config.urls.candidate.fetchCandidate.url.replace( ':id', id ) )
                       .then( response => {
                           this.candidate = response.data.data;
                       } ).catch(()=>{});
        }
    }
}

export default CandidateMixin;
